import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterAction } from "../../../shared/cubiq-services";

export enum BfxContextMenuItemMode {
  OPTIMISTIC,
  PESSIMISTIC,
}

export const FILL_APPROVE_REASONS = [CubiqTS.DIReason.FILL_WITHELD];

export const FILL_CANCEL_REASONS = [CubiqTS.DIReason.FILL_WITHELD];

export const FILL_CLEAR_REASONS = [CubiqTS.DIReason.FILL_NOT_RECEIVED];

export const FWDROLL_RETRY_REASONS = [CubiqTS.DIReason.PORTFOLIO_FWD_ROLL_ERROR];

export const SALES_APPROVAL_REASONS = [
  CubiqTS.DIReason.ENTRY_CREDIT_FAIL,
  CubiqTS.DIReason.CREDIT_CANCEL_FAIL,
  CubiqTS.DIReason.CREDIT_CANCEL_TIMEOUT,
  CubiqTS.DIReason.CREDIT_EXPIRY_FAIL,
  CubiqTS.DIReason.CREDIT_EXPIRY_TIMEOUT,
  CubiqTS.DIReason.MODIFY_CREDIT_FAIL,
  CubiqTS.DIReason.FORCE_TO_DI,
  CubiqTS.DIReason.DAILY_REVAL_CREDIT_FAIL,
  CubiqTS.DIReason.PROXIMITY_REVAL_CREDIT_FAIL,
  CubiqTS.DIReason.MODIFY_CREDIT_PROXIMITY_FAIL,
  CubiqTS.DIReason.ENTRY_CREDIT_PROXIMITY_FAIL,
  CubiqTS.DIReason.FILL_CREDIT_FAIL,
  CubiqTS.DIReason.CREDIT_REJECT_FAIL,
  CubiqTS.DIReason.CREDIT_REJECT_TIMEOUT,
];

export const SALES_REJECT_REASONS = [
  CubiqTS.DIReason.ENTRY_CREDIT_FAIL,
  CubiqTS.DIReason.MODIFY_CREDIT_FAIL,
  CubiqTS.DIReason.MODIFY_CREDIT_PROXIMITY_FAIL,
  CubiqTS.DIReason.ENTRY_CREDIT_PROXIMITY_FAIL,
  CubiqTS.DIReason.FORCE_TO_DI,
];

export const TRADER_ACCEPT_REJECT_REASONS = [
  CubiqTS.DIReason.SOFT_CUT_OFF,
  CubiqTS.DIReason.CANCEL_DURING_SOFT_CUT_OFF,
];

export const CANCEL_REASONS = [
  CubiqTS.DIReason.DAILY_REVAL_CREDIT_FAIL,
  CubiqTS.DIReason.PROXIMITY_REVAL_CREDIT_FAIL,
];

export const AMEND_MARKUP_REASONS = [CubiqTS.DIReason.FORCE_TO_DI];

export const ITEM_STATE_AVAILABLE_MODE_MAPPING = new Map<BfxBlotterAction, BfxContextMenuItemMode>([
  [BfxBlotterAction.ACTION_DI_ACCEPT, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_TRADER_REJECT, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_APPROVE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_REJECT, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_CANCEL, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_AMEND_MARKUP, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_MANUAL_PRICE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_UNLOCK, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FILL_APPROVE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FILL_CANCEL, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FILL_CLEAR, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FWD_ROLL_PRICE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FWD_ROLL_CLEAR, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FWD_ROLL_RETRY, BfxContextMenuItemMode.OPTIMISTIC],
]);

export const ITEM_STATE_ENABLED_MODE_MAPPING = new Map<BfxBlotterAction, BfxContextMenuItemMode>([
  [BfxBlotterAction.ACTION_DI_ACCEPT, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_TRADER_REJECT, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_APPROVE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_REJECT, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_CANCEL, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_AMEND_MARKUP, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_MANUAL_PRICE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_UNLOCK, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FILL_APPROVE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FILL_CANCEL, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FILL_CLEAR, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_DI_FWD_ROLL_PRICE, BfxContextMenuItemMode.PESSIMISTIC],
  [BfxBlotterAction.ACTION_DI_FWD_ROLL_CLEAR, BfxContextMenuItemMode.PESSIMISTIC],
  [BfxBlotterAction.ACTION_DI_FWD_ROLL_RETRY, BfxContextMenuItemMode.PESSIMISTIC],
]);

/**
 * Some actions can not be OPTIMISTIC no matter how hard you try to cheer them up.
 * Seriously, this is an override on the mappings above, DO NOT MODIFY!
 */
export const ITEM_STATE_ENABLED_MUST_BE_PESSIMISTIC = [
  BfxBlotterAction.ACTION_DI_CANCEL,
  BfxBlotterAction.ACTION_DI_FILL_APPROVE,
  BfxBlotterAction.ACTION_DI_FILL_CANCEL,
  BfxBlotterAction.ACTION_DI_FILL_CLEAR,
];
